import { Component, Output, EventEmitter, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminService } from '../../admin.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-upload-handlebar-template',
  templateUrl: './upload-handlebar-template.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class UploadHandlebarTemplateComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  uploadHandlebarTemplate: {
    id: null | string;
    status: null | string;
    statusClass: null | string;
  } = {
    id: null,
    status: null,
    statusClass: null,
  };
  handlebarFile: File;
  handlebarFileName;
  deleteFile;
  deleteFileName;
  uploadFile;
  uploadFileName;

  onFileSelected(event) {
    this.handlebarFile = event.target.files[0];
    if (this.handlebarFile) {
      this.handlebarFileName = this.handlebarFile.name;
    }
  }

  uploadHandlebarTemplateFile() {
    this.toggleLoading.emit();
    this.uploadHandlebarTemplate.status = null;
    this.uploadHandlebarTemplate.statusClass = null;

    this.handlebarFile.text().then((fileContent: string) => {
      this.admnSrvc
        .uploadeHandlebarTemplate(this.uploadHandlebarTemplate.id, fileContent)
        .subscribe({
          next: res => {
            if (res instanceof HttpErrorResponse) {
              this.toggleLoading.emit();
              this.uploadHandlebarTemplate.status = `${res.status} - ${res.statusText} - ${res.message}`;
              this.uploadHandlebarTemplate.statusClass = 'failure';
              return throwError(() => res.error || 'Server error');
            } else {
              this.toggleLoading.emit();
              this.uploadHandlebarTemplate.status = res.result;
              this.uploadHandlebarTemplate.statusClass = 'success';
            }
          },
          error: catchError(err => {
            this.toggleLoading.emit();
            this.uploadHandlebarTemplate.status = err;
            this.uploadHandlebarTemplate.statusClass = 'failure';
            return throwError(() => err.error || 'Server error');
          }),
        });
    });
  }
}
